import React, { memo, useMemo } from 'react';
import clsx from 'clsx';
import { FiltersSlider } from '@alf/uikit';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { PandascoreBlock } from '../../constants';

import styles from './index.module.css';

interface PandascoreTabsProps {
  selectedTab: string;
  handleSelectTab: (selectedTab: string) => void;
}

const PandascoreTabs = ({
  selectedTab,
  handleSelectTab
}: PandascoreTabsProps) => {
  const { t } = useI18n();
  const { isMobile } = useDeviceStore();

  const tabs = useMemo(
    () => [
      {
        icon: 'icons/pandascore/general-stats',
        label: t('web.sportsbook.pandascore.generalstats'),
        id: PandascoreBlock.GENERAL_STATS
      },
      {
        icon: 'icons/pandascore/head-to-head',
        label: t('web.sportsbook.pandascore.headtohead'),
        id: PandascoreBlock.HEAD_TO_HEAD
      },
      {
        icon: 'icons/pandascore/form-guide',
        label: t('web.sportsbook.pandascore.formguide'),
        id: PandascoreBlock.FORM_GUIDE
      },
      {
        icon: 'icons/pandascore/team-stats',
        label: t('web.sportsbook.pandascore.teamsstats'),
        id: PandascoreBlock.TEAM_STATS
      },
      {
        icon: 'icons/pandascore/player-stats',
        label: t('web.sportsbook.pandascore.playerstats'),
        id: PandascoreBlock.PLAYER_STATS
      }
    ],
    [t]
  );

  return (
    <FiltersSlider
      items={tabs}
      selectedItems={[selectedTab]}
      onChange={(tab) => handleSelectTab(tab as PandascoreBlock)}
      classNames={{
        containerClassName: styles.wrapper,
        buttonClassName: styles.buttonClassName,
        itemClassName: styles.item,
        textClassName: clsx(styles.textClassName, isMobile && styles.hidden),
        activeClassName: styles.active,
        activeTextClassName: styles.activeItemText
      }}
    />
  );
};

export default memo(PandascoreTabs);
